import { isEqual } from 'lodash'

export const hasFormChanged = <T>(
  values: T,
  initialValues: T,
  ignoreFields: (keyof T)[] = [],
): boolean => {
  const filteredValues = { ...values }
  const filteredInitialValues = { ...initialValues }

  ignoreFields.forEach((field) => {
    delete filteredValues[field]
    delete filteredInitialValues[field]
  })

  return !isEqual(filteredValues, filteredInitialValues)
}
